import { OrganizationTypes, TypologiesEnum } from '../enums';

export interface IAuthOrganizationOutputDto {
    id: string; // mongo id
    email: string;
    name: string;
    externalId: string; // used to reference the organization in other platforms. Is often the platform's id of the parent user
    settings?: Record<string, unknown>;
    locale?: string;
    photo?: string;
    timezone?: string;
    organizationTypes?: OrganizationTypes[];
}

export interface IAuthMeV2OutputDto {
    id: string; // mongo user id
    externalId: string; // platform user id (depends on user typology)
    firstName: string;
    lastName: string;
    phone?: string;
    email: string;
    organizations: IAuthOrganizationOutputDto[];
    currentOrganization: string;
    permissions: string[];
    applications: string[];
    apiKey?: string;
    personalApiKey?: string;
    tntOrgKey?: string;
    typology: TypologiesEnum;
    roles: string[];
    applicationModules?: { application: string; modules: string[] }[];
    settings?: Record<
        string,
        | {
              ['stork:vehicles_to_view']?: { carrierId: string; vehicleIds: string[] }[];
              ['stork:drivers_to_view']?: { carrierId: string; driverIds: string[] }[];
              ['stork:is_demo']?: boolean;
          }
        | unknown
    >;
    locale?: string;
    originalLoginId?: string;
    originalUserData?: {
        email: string;
        externalId: string;
        id: string;
    };
}
